module.exports = "<p>\n  Forwarding...\n</p>"


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/login/login.component.html
// module id = ../../../../../src/app/login/login.component.html
// module chunks = main